export default __webpack_public_path__ + "static/media/portada.b7937bc3.jpg";